// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_iw-0";
export var fulfillmentPanelBody = "_iw-1";